import {React} from 'react'
import RightArrowIcon from './../../assets/svg-icons/rightArrow'
import { useNavigate } from "react-router-dom";
import { ROUTES } from '../../constant/routes';
import { FONT_PAIR_HEADER,FONT_PAIR_BODY } from '../../constant';
import { useDispatch } from "react-redux";
import { CHANGE_FONT} from "../../store/types/font";


const ExploreMorePairs = ({item}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate()

  return (
    <div className="font-pair-box listing-paired-box p-3 pb-5 col-xs-12 col-md-6 col-lg-4">
      {/* <p className="liked23"><img src={LikedThumb} alt="like" /> Liked on {item.createdAt}</p> */}
      <ul>
            <li>{item.likedPair[2]}</li>
            <li>&</li>
            <li>{item.likedPair[3]}</li>
        </ul>
        <h2  dangerouslySetInnerHTML={{ __html: FONT_PAIR_HEADER.toString() }}  style={{fontFamily: `"${item.likedPair[2]}"` }} />
        <p   dangerouslySetInnerHTML={{ __html: FONT_PAIR_BODY.toString() }} style={{fontFamily: `"${item.likedPair[3]}"` }}></p>
        <div className='font-playerground-sec'>
        <h6>
          <div className='GA_redirectPlaygroundFromMorePage' onClick={() => {
      //             setDoc({
      //   fontPair1: item.likedPair[2],
      //   fontPair2: item.likedPair[3]
      // });
      dispatch({ type: CHANGE_FONT, payload: [ item.likedPair[2], item.likedPair[3] ] })
      navigate(`${ROUTES.PLAYGROUND}?fontPair1=${item.likedPair[2]}&fontPair2=${item.likedPair[3]}`);

      }}>Try in playground 
          <RightArrowIcon className='ms-2' />
          </div>
        </h6>
      </div>
    </div>
  )
}

export default ExploreMorePairs